import { Box, Button, Stack, Tab, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  NoDataWarning,
  PageTitle,
  PrimaryButton,
  SecondaryButton,
} from "../../../components/common";
import { GenericTable } from "../../../components/GenericTable/GenericTable";
import { ManageProtocolActions } from "./ManageProtocolActions";
import { usePractitionerRoleContext } from "../../../contexts/PractitionerRoleContext";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDict } from "../../../utils/useDict";
import { useFormatter } from "../../../utils/useFormatter";
import { useContractContext } from "../../../contexts/ContractContext";
import { PageHeader } from "@/components/common/PageHeader";
import { Add, ArrowBack, InfoOutlined, Settings } from "@mui/icons-material";
import { useState } from "react";

export function ManageProtocol({ data, setRefetch }: any) {
  const { practitioner } = usePractitionerRoleContext();
  const { currentContract } = useContractContext();
  const navigate = useNavigate();

  // Estado para controlar a tab selecionada
  const [selectedTab, setSelectedTab] = useState("all");

  // Opções de categorias (mesmas do CreateProtocolDialog)
  const categoryOptions = [
    { value: "1", label: "Clínico" },
    { value: "2", label: "Rotina" },
    { value: "3", label: "Cirúrgico" },
    { value: "4", label: "Urgência" },
    { value: "5", label: "Pesquisa" },
  ];

  // Handler para mudança de tab
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  const columns = [
    {
      column: "Nome",
      rowName: "name",
    },
    { column: "Categoria", rowName: "category" },
    // { column: "Organização", rowName: "organization" },
    { column: "Autor", rowName: "practioner" },
    { column: "Status", rowName: "statusValue" },
    { column: "Ultima modificação", rowName: "lastUpdated" },
    { column: "Ultimo editor", rowName: "subject" },
    { column: "Versões", rowName: "version" },
  ];

  const rows = data?.map((el: any) => {
    // const auxOrganization = organizationList?.find(
    //   (organization: any) =>
    //     organization?.resource?.id?.split("/")?.pop() ===
    //     el?.resource?.author?.reference?.split("/")?.pop()
    // )?.resource?.alias?.[0];
    const auxPracitioner = useFormatter.formatNameDisplay(
      practitioner?.find(
        (practitioners: any) =>
          practitioners?.resource?.id ===
          el?.resource?.source?.reference?.split("/")?.pop(),
      )?.resource?.name?.[0]?.text || "-",
    );

    const auxLastEditor = useFormatter.formatNameDisplay(
      practitioner?.find(
        (practitioners: any) =>
          practitioners?.resource?.id ===
          el?.resource?.subject?.reference?.split("/")?.pop(),
      )?.resource?.name?.[0]?.text || "-",
    );

    const auxName = el?.resource?.item?.find(
      (e: any) => e.linkId === "438586562091",
    )?.answer?.[0]?.valueString;

    const category = el?.resource?.item?.find(
      (e: any) => e.linkId === "category",
    )?.answer?.[0]?.valueString;

    return {
      id: el?.resource?.id,
      statusValue: el?.resource?.status
        ? useDict.protocolStatus[el?.resource?.status]
        : "-",
      name: auxName || "",
      // organization: auxOrganization,
      practioner: auxPracitioner,
      subject: auxLastEditor || auxPracitioner,
      itens: el,
      category: category || "",
      version: el?.resource?.meta?.versionId,
      lastUpdated: dayjs(el?.resource?.meta?.lastUpdated)?.format("DD/MM/YYYY"),
    };
  });

  return (
    <>
      <Stack width="100%" sx={{ height: "100%" }} spacing={2}>
        <PageHeader
          title="Gerenciar protocolos"
          icon={Settings}
          action={
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => navigate("/createprotocol")}
              // disabled={!currentContract}
            >
              Novo protocolo
            </Button>
          }
        />

        <TabContext value={selectedTab}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <TabList onChange={handleChangeTab}>
              <Tab label="Todos" value="all" />
              {categoryOptions.map((category) => (
                <Tab
                  key={category.value}
                  label={category.label}
                  value={category.value}
                />
              ))}
            </TabList>
          </Box>

          {/* Tab "Todos" - mostra todos os protocolos */}
          <TabPanel value="all" sx={{ padding: 0 }}>
            <GenericTable
              tableColumns={columns}
              tableRows={rows}
              actions={(row: any) => (
                <ManageProtocolActions
                  row={row}
                  data={data}
                  setRefetch={setRefetch}
                />
              )}
            />
          </TabPanel>

          {/* Tabs por categoria - filtra protocolos pela categoria */}
          {categoryOptions.map((category) => (
            <TabPanel key={category.value} value={category.value}>
              <GenericTable
                tableColumns={columns}
                tableRows={rows?.filter(
                  (row: any) => row.category === category.label,
                )}
                actions={(row: any) => (
                  <ManageProtocolActions
                    row={row}
                    data={data}
                    setRefetch={setRefetch}
                  />
                )}
              />
            </TabPanel>
          ))}
        </TabContext>
      </Stack>
    </>
  );
}
